/**
 * @generated SignedSource<<143dee286fd03753c465b95c9fbd6b98>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TraceHeaderTraceAnnotationsFragment$data = {
  readonly project: {
    readonly " $fragmentSpreads": FragmentRefs<"ProjectAnnotationConfigsByNameFragment">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"TraceAnnotationSummaryGroup">;
  readonly " $fragmentType": "TraceHeaderTraceAnnotationsFragment";
};
export type TraceHeaderTraceAnnotationsFragment$key = {
  readonly " $data"?: TraceHeaderTraceAnnotationsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TraceHeaderTraceAnnotationsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TraceHeaderTraceAnnotationsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Project",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProjectAnnotationConfigsByNameFragment"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TraceAnnotationSummaryGroup"
    }
  ],
  "type": "Trace",
  "abstractKey": null
};

(node as any).hash = "0894024a229b8cd7df2cd99524b6456a";

export default node;
